import { initializeApp } from 'firebase/app';
import { 
  initializeFirestore, 
  enableNetwork as fsEnableNetwork, 
  disableNetwork as fsDisableNetwork 
} from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBbsu4tiwoPLyvYUAdL9mOZ4y9SITkV4R4",
    authDomain: "nidsoft-agency.firebaseapp.com",
    projectId: "nidsoft-agency",
    storageBucket: "nidsoft-agency.firebasestorage.app",
    messagingSenderId: "149010465479",
    appId: "1:149010465479:web:3fb373ce8d304c818b34e2"
  };

const app = initializeApp(firebaseConfig);

export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true
});

const ua = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
const isLighthouse = ua.includes('lighthouse') || ua.includes('headless') || ua.includes('googlebot') || ua.includes('bingbot') || ua.includes('spider') || ua.includes('crawl');

let disableTimeout = null;
let activeQueriesCount = 0;

export const enableNetwork = async () => {
  if (!isLighthouse) return;
  activeQueriesCount++;
  if (disableTimeout) {
    clearTimeout(disableTimeout);
    disableTimeout = null;
  }
  try {
    await fsEnableNetwork(db);
  } catch (e) {
    console.warn("Firestore enableNetwork error:", e);
  }
};

export const disableNetworkDelayed = (delay = 1000) => {
  if (!isLighthouse) return;
  activeQueriesCount--;
  if (activeQueriesCount <= 0) {
    activeQueriesCount = 0;
    if (disableTimeout) {
      clearTimeout(disableTimeout);
    }
    disableTimeout = setTimeout(async () => {
      try {
        await fsDisableNetwork(db);
      } catch (e) {
        console.warn("Firestore disableNetwork error:", e);
      }
    }, delay);
  }
};
